import React, { useContext } from 'react';
import Cards from 'browser/components/Cards';
import Table from 'browser/components/Table';
import {
  Section,
  Content,
  FlatsContent,
  EmptyInfo,
  FiltersWrapper,
  FilterColumn,
  CheckboxWrapper,
  Checkmark,
  FilterInfo,
  InfoWrapper,
  ViewButtonsWrapper,
  FilterItem,
} from 'browser/components/FlatsBrowser/components';
import Pagination from 'browser/components/Pagination';
import { ViewButton } from 'browser/components/Button';
import RangeInput from 'browser/components/Filters/RangeInput';
import TourModal from 'browser/components/Flat/TourModal';
import { LangContext } from 'browser/contexts/LangContext';
import Select from 'browser/components/Filters/Select';
import FlatForm from 'browser/components/Form/Form';
import useFlats from 'browser/hooks/useFlats';

const Flats = () => {
  const { translate } = useContext(LangContext);
  const {
    formState,
    tour3DState,
    filters,
    allFlats,
    saleOnly,
    filteredParkingSpots,
    filteredFlats,
    selectedFloorsText,
    firstFloor,
    lastFloor,
    viewType,
    pages,
    activePage,
    sortProperty,
    uniqueLayoutsNum,
    handleSetViewType,
    setSaleOnly,
    showTour3D,
    closeTour3D,
    handleSetSortProperty,
    updateFlats,
    onButtonClick,
    setActivePage,
    closeForm,
    toggleForm,
    handleRoomsMultiSelect,
    handleFloorMultiSelect,
    handleAreaRange,
    handlePriceRange,
  } = useFlats();

  return (
    <>
      {tour3DState.src && (
        <TourModal
          src={tour3DState.src}
          isVisible
          flat={tour3DState.flat}
          close={closeTour3D}
        />
      )}

      <FlatForm
        isVisible={formState.visible}
        flat={formState.name}
        investment={formState.investment}
        heading={
          formState.bookFlat ? translate('bookFlat') : translate('askAboutFlat')
        }
        closeForm={closeForm}
        bookFlat={formState.bookFlat}
      />

      <Section>
        <Content short>
          <FilterColumn>
            <FiltersWrapper>
              <FilterItem>
                <p>{translate('numberOfRooms')}</p>
                <Select
                  allOptions={filters.rooms.all.sort((a, b) => a - b)}
                  selectedOptions={filters.rooms.selected.sort((a, b) => a - b)}
                  handleSelect={handleRoomsMultiSelect}
                  placeholder={translate('chooseFromList')}
                  multiSelect
                  first
                />
              </FilterItem>
              <FilterItem>
                <p>{translate('floor')}</p>
                <Select
                  allOptions={filters.floors.all.sort((a, b) => a - b)}
                  selectedOptions={filters.floors.selected.sort(
                    (a, b) => a - b
                  )}
                  handleSelect={handleFloorMultiSelect}
                  placeholder={translate('chooseFromList')}
                  multiSelect
                />
              </FilterItem>
              <FilterItem>
                <p>{translate('surface')}</p>
                <RangeInput
                  value={filters.area.values}
                  min={filters.area.extremes[0]}
                  max={filters.area.extremes[1]}
                  handleChange={handleAreaRange}
                  unit="m2"
                />
              </FilterItem>
              {filters.price &&
                !!(filters.price.values[0] && filters.price.values[0]) && (
                  <FilterItem>
                    <p>{translate('price')}</p>
                    <RangeInput
                      value={filters.price.values}
                      min={filters.price.extremes[0]}
                      max={filters.price.extremes[1]}
                      handleChange={handlePriceRange}
                      unit="PLN"
                      minDistance={50000}
                    />
                  </FilterItem>
                )}
            </FiltersWrapper>
            {allFlats
              .filter(({ status }) => status !== 3)
              .some(flat => !flat.isPriceVisible) && (
              <CheckboxWrapper onClick={() => setSaleOnly(!saleOnly)}>
                <Checkmark checked={saleOnly} />
                <span>{translate('sale')}</span>
              </CheckboxWrapper>
            )}

            <InfoWrapper>
              <FilterInfo>
                Mamy dla Ciebie <b>{uniqueLayoutsNum} mieszkań i {filteredParkingSpots.length} miejsca garażowe.</b>
              </FilterInfo>
              <ViewButtonsWrapper>
                <ViewButton
                  onClick={() => handleSetViewType('cards')}
                  active={viewType === 'cards'}
                >
                  {translate('cardView')}
                </ViewButton>
                <ViewButton
                  onClick={() => handleSetViewType('list')}
                  active={viewType === 'list'}
                  list
                >
                  {translate('listView')}
                </ViewButton>
              </ViewButtonsWrapper>
            </InfoWrapper>
          </FilterColumn>
        </Content>
        <FlatsContent id="flats2d-content" short list={viewType === 'list'}>
          {viewType === 'cards' && (
            <Cards
              flats={pages[activePage]}
              allFlats={filteredFlats.sort(
                (a, b) => Number(b.isPromo) - Number(a.isPromo)
              )}
              showTour3D={showTour3D}
              toggleForm={toggleForm}
            />
          )}
          {viewType === 'list' && (
            <Table
              sortProperty={sortProperty}
              setSortProperty={handleSetSortProperty}
              columns={[
                { label: translate('flat'), property: 'name' },
                { label: translate('area'), property: 'area' },
                { label: translate('floor'), property: 'floor' },
                { label: translate('rooms'), property: 'rooms' },
                { label: translate('balcony'), property: 'balcony' },
                { label: translate('price'), property: 'price' },
                { label: translate('status'), property: 'status' },
              ]}
              flats={pages[activePage]}
              setSortedFlats={updateFlats}
              onButtonClick={onButtonClick}
              toggleForm={toggleForm}
            />
          )}
          {filteredFlats.length === 0 && (
            <EmptyInfo>
              <p>{translate('noMatchingFlats')}</p>
            </EmptyInfo>
          )}
        </FlatsContent>
        <Content short>
          {pages.length > 1 && (
            <Pagination
              activePage={activePage}
              setActivePage={setActivePage}
              totalPages={pages.length}
              selector="#flats2d-content"
            />
          )}
        </Content>
      </Section>
    </>
  );
};

export default Flats;
